const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'LOGOUT':
      return defaultState;
    case 'SET_PLACE':
      return action.place;
    case 'SET_PLACE_CLANS':
      return {
        ...state,
        clans: action.clans
      };
    case 'SET_PLACE_NAME':
      return {
        ...state,
        name: action.name
      };
    case 'SET_PLACE_SITES':
      return {
        ...state,
        sites: action.sites
      };
    case 'SET_PLACE_UID':
      return {
        ...state,
        placeUid: action.placeUid
      };
    case 'SET_PLACE_USERS':
      return {
        ...state,
        users: action.users
      };
    case 'SET_PLACE_USERS_QUEUE':
      return {
        ...state,
        usersQueue: action.usersQueue
      };
    case 'SET_PLACE_VEHICLES':
      return {
        ...state,
        vehicles: action.vehicles
      };
    default:
      return state;
  }
};
